import { render, staticRenderFns } from "./EmailVerified.vue?vue&type=template&id=381e491a&scoped=true"
import script from "./EmailVerified.vue?vue&type=script&lang=js"
export * from "./EmailVerified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e491a",
  null
  
)

export default component.exports